import React from "react";

// Logos
import java from "../IMG/java.gif";
import javascript from "../IMG/javascript.gif";
import TypeScript from "../IMG/TypeScript.png";
import cpp from "../IMG/C++.png";
import PHP from "../IMG/php.png";

import Reactlogo from "../IMG/react.gif";
import Vue from "../IMG/vue.png";
import Node from "../IMG/node.png";
import Express from "../IMG/ecpress.png";
import Tailwind from "../IMG/Tailwind.png";
import Spring from "../IMG/Spring Boot.png";

import MySQL from "../IMG/MySQL.png";
import MongoDB from "../IMG/MongoDB.png";
import Firebase from "../IMG/Firebase.png";
import AWS from "../IMG/AWS.png";
import Flutter from "../IMG/Flutter.png";
import Android from "../IMG/Android.png";
import Figma from "../IMG/Figma.gif";
import WordPress from "../IMG/wordpress logo.png";

import postman from "../IMG/postman.png";
import github from "../IMG/GitHub.png";
import docker from "../IMG/docker.png";
import cicd from "../IMG/cicd.png";
import xd from "../IMG/xd.gif";

// ---------------- DATA ---------------- //

const handsOnSkills = [
  {
    category: "Languages",
    skills: [
      { name: "Java", level: 90, logo: java },
      { name: "JavaScript", level: 85, logo: javascript },
      { name: "TypeScript", level: 85, logo: TypeScript },
      { name: "SQL", level: 85, logo: MySQL },
    ],
  },
  {
    category: "Frontend",
    skills: [
      { name: "React.js", level: 90, logo: Reactlogo },
      { name: "Vue.js", level: 60, logo: Vue },
      { name: "React Native", level: 70, logo: Reactlogo },
      { name: "Tailwind CSS", level: 95, logo: Tailwind },
    ],
  },
  {
    category: "Backend",
    skills: [
      { name: "Spring Boot", level: 80, logo: Spring },
      { name: "Node.js", level: 70, logo: Node },
      { name: "Express.js", level: 70, logo: Express },
      { name: "REST APIs", level: 85, logo: postman },
    ],
  },
  {
    category: "Cloud & DevOps",
    skills: [
      { name: "AWS", level: 70, logo: AWS },
      { name: "Docker", level: 90, logo: docker },
      { name: "CI/CD", level: 75, logo: cicd },
      { name: "Git & GitHub", level: 85, logo: github },
    ],
  },
  {
    category: "Databases",
    skills: [
      { name: "MySQL", level: 85, logo: MySQL },
      { name: "MongoDB", level: 75, logo: MongoDB },
    ],
  },
];

const knowledgeSkills = [
  {
    category: "Languages",
    skills: ["C++", "PHP"],
  },
  {
    category: "Tools & Platforms",
    skills: [
      "Firebase",
      "Flutter",
      "Android Studio",
      "Figma",
      "Adobe XD",
      "WordPress",
    ],
  },
];

// ---------------- COMPONENT ---------------- //

function Skill_main() {
  return (
    <>


      <div className="bg-white rounded-md shadow-md p-8">
        {/* Header */}
        <div className="">
          <h1 className="text-2xl font-bold tracking-wide">
            Skills & Expertise
          </h1>
          <p className="text-gray-600 mt-2">
            A blend of hands-on engineering experience and strong technical
            knowledge.
          </p>
        </div>

        {/* HANDS ON EXPERIENCE */}
        <div className="">
          <h2 className="text-xl font-semibold mb-2">Hands-On Experience</h2>
          <p className="text-gray-500 mb-6">
            Technologies I have used extensively in production-level projects.
          </p>

          {handsOnSkills.map((group, idx) => (
            <div key={idx} className="mb-8">
              <h3 className="font-medium mb-4">{group.category}</h3>

              {group.skills.map((skill, i) => (
                <div key={i} className="flex items-center gap-4 mb-4">
                  <img
                    src={skill.logo}
                    alt={skill.name}
                    className="w-8 h-8 object-contain"
                  />

                  <div className="w-full">
                    <div className="flex justify-between text-sm mb-1">
                      <span>{skill.name}</span>
                      <span className="text-gray-500">{skill.level}%</span>
                    </div>

                    <div className="h-2 bg-gray-200 rounded-full">
                      <div
                        className="h-2 bg-black rounded-full transition-all duration-700"
                        style={{ width: `${skill.level}%` }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* WORKING KNOWLEDGE */}
        <div>
          <h2 className="text-xl font-semibold mb-2">Working Knowledge</h2>
          <p className="text-gray-500 mb-6">
            Tools and technologies I understand well and have hands-on exposure
            to.
          </p>

          {knowledgeSkills.map((group, idx) => (
            <div key={idx} className="mb-6">
              <h3 className="font-medium mb-3">{group.category}</h3>

              <div className="flex flex-wrap gap-3">
                {group.skills.map((skill, i) => (
                  <span
                    key={i}
                    className="px-4 py-2 text-sm rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skill_main;
